import React from "react";
import { Text, Flex, Box, Spinner, type FlexProps, type IconProps } from "@chakra-ui/react";
import {
  FacebookIcon,
  FacebookMonoIcon,
  GoogleAdsIcon,
  GoogleAdsMonoIcon,
  TikTokIcon,
  TikTokMonoIcon,
} from "ui/icons/integrations";
import { CheckIcon } from "ui/icons";

function IconRow({
  text,
  iconMono,
  iconColor,
}: {
  text: string;
  iconMono: (props: IconProps) => JSX.Element;
  iconColor: (props: IconProps) => JSX.Element;
}) {
  return (
    <Flex align="center" gap={{ base: "smallest", lg: "smaller" }}>
      <Box boxSize={{ base: "icon.md", lg: "icon.lg" }} pos="relative">
        <Box as={iconMono} pos="absolute" inset={0} boxSize="100%" opacity={0.7} />
        <Box as={iconColor} pos="absolute" inset={0} boxSize="100%" opacity={0} />
      </Box>

      <Text flex={1} textStyle="body3" fontSize={{ base: "brand.sm", lg: "brand.md" }}>
        {text}
      </Text>
    </Flex>
  );
}

export function DestinationMenu(props: FlexProps) {
  return (
    <Flex
      bg="brand.background.light"
      borderRadius="smallest"
      boxShadow="md"
      color="brand.text.light"
      direction="column"
      gap={{ base: "smaller", lg: "small" }}
      p={{ base: "smaller", lg: "small" }}
      w={{ base: "220px", md: "240px", lg: "280px", xl: "340px" }}
      {...props}
    >
      <Flex align="center" gap="smallest" justify="space-between">
        <Text
          textStyle="body3"
          fontSize={{ base: "brand.sm", lg: "brand.md" }}
          textTransform="uppercase"
          fontWeight="semibold"
        >
          Sync audience
        </Text>
        <Flex align="center" justify="center" boxSize="icon.lg" pos="relative">
          <Spinner
            id="funnels-menu-spinner"
            boxSize="icon.md"
            borderWidth="2.5px"
            color="new.green.700"
            emptyColor="new.gray.300"
            pos="absolute"
            inset={0}
            m="auto"
            opacity={0}
          />

          <CheckIcon
            id="funnels-check-svg"
            boxSize="100%"
            color="brand.accent.secondary"
            pos="absolute"
            inset={0}
            opacity={0}
          />
        </Flex>
      </Flex>

      <IconRow
        iconMono={(props: IconProps) => <FacebookMonoIcon id="funnels-fb--mono" {...props} />}
        iconColor={(props: IconProps) => <FacebookIcon id="funnels-fb--color" {...props} />}
        text="Facebook"
      />

      <IconRow
        iconMono={(props: IconProps) => <GoogleAdsMonoIcon id="funnels-ga--mono" {...props} />}
        iconColor={(props: IconProps) => <GoogleAdsIcon id="funnels-ga--color" {...props} />}
        text="Google Ads"
      />

      <IconRow
        iconMono={(props: IconProps) => <TikTokMonoIcon id="funnels-tiktok--mono" {...props} />}
        iconColor={(props: IconProps) => <TikTokIcon id="funnels-tiktok--color" {...props} />}
        text="TikTok"
      />
    </Flex>
  );
}
